import PermissionDenied from './accessDenied';
import Analytics from './analytics';
import ForgotPassword from './auth/ForgotPassword';
import Login from './auth/Login';
import ResetPassword from './auth/ResetPassword';
import Verification from './auth/Verification';
import Blogs from './blogs';
import AddBlog from './blogs/add';
import BodyType from './bodyType';
import AddBodyType from './bodyType/add';
import Brands from './brands';
import AddBrand from './brands/add';
import TrimBrand from './brands_trim';
import AddTrimBrand from './brands_trim/add';
import BroadcastMessage from './broadcastMessage';
import Chat from './chat';
import ColorCode from './colorCode';
import AddColorCode from './colorCode/add';
import ManageCustomerSupport from './customerSupport';
import Dashboard from './dashboard';
import DealerListings from './dealerListings';
import Dealers from './dealers';
import DownloadedUsers from './downloadedUsers';
import DriveType from './driveType';
import AddDriveType from './driveType/add';
import EditProfile from './editProfile';
import EngineCapacity from './engineCapacity';
import AddEngineCapacity from './engineCapacity/add';
import ManageEquipments from './equipments';
import AddEquipment from './equipments/add';
import ManageFeatures from './features';
import AddFeatures from './features/add';
import FinancialYears from './financeYears';
import AddFinancialYear from './financeYears/add';
import FinancialRequests from './financialRequests';
import FleetDamage from './fleetDamage';
import AddFleetDamage from './fleetDamage/add';
import FuelType from './fuelType';
import AddFuelType from './fuelType/add';
import ManageGCC from './gcc';
import AddGCC from './gcc/add';
import IndividualListings from './individualListings';
import Individuals from './individuals';
import InspectionRequests from './inspectionRequests';
import LoanInterestRates from './loanInterestRates';
import AddLoanInterestRates from './loanInterestRates/add';
import ManageCms from './manageCms';
import ManageNotifications from './manageNotifications';
import ManagePackages from './managePackages';
import AddPackage from './managePackages/add';
import Modal from './modal';
import AddModal from './modal/add';
import TrimModal from './modal_trim';
import AddTrimModal from './modal_trim/add';
import MyListings from './myListings';
import AddVehicle from './myListings/add';
import MyProfile from './myProfile';
import NewsLetterEmail from './newsletterEmail';
import Payment from './payment';
import Power from './Power';
import AddPower from './Power/add';
import ProfileDetail from './ProfileDetail';
import ManagePromoCodes from './promoCodes';
import AddPromoCode from './promoCodes/add';
import PromoCodeDetail from './promoCodes/view';
import PromotionalCampaign from './promotionalCampaign';
import AddPromotionalCampaign from './promotionalCampaign/add';
import RatingsAndReviews from './ratingsAndReviews';
import RecievedNotifications from './recievedNotifications';
import RegionalSpec from './regionalSpec';
import AddRegionalSpec from './regionalSpec/add';
import RegisteredUsers from './registeredUsers';
import ReportAnIssue from './reportAnIssue';
import Reports from './reports';
import DealerStoreDetail from './storeDealer/detail';
import ManageStore from './storeDealer/index';
import StoreListings from './storeListings';
import Stores from './stores';
import ManageTechFeatures from './technicalFeatures';
import AddTechnicalFeatures from './technicalFeatures/add';
import Roles from './userManagement/role';
import UserList from './userManagement/userList';
import VehicleDetail from './vehicleDetail';
import VehicleTypes from './vehicleTypes';
import AddVehicleTypes from './vehicleTypes/add';

export default {
  Login,
  Dashboard,
  ForgotPassword,
  ResetPassword,
  Individuals,
  Stores,
  Dealers,
  Blogs,
  AddBlog,
  Verification,
  InspectionRequests,
  ManagePackages,
  AddPackage,
  ManagePromoCodes,
  AddPromoCode,
  PromoCodeDetail,
  VehicleTypes,
  AddVehicleTypes,
  IndividualListings,
  DealerListings,
  StoreListings,
  MyListings,
  AddVehicle,
  Brands,
  BodyType,
  AddBrand,
  AddBodyType,
  PromotionalCampaign,
  AddPromotionalCampaign,
  RatingsAndReviews,
  VehicleDetail,
  MyProfile,
  FuelType,
  AddFuelType,
  EngineCapacity,
  AddEngineCapacity,

  DownloadedUsers,

  RegisteredUsers,

  ReportAnIssue,

  Reports,
  Roles,
  UserList,
  BroadcastMessage,
  Chat,
  ProfileDetail,
  EditProfile,
  ManageNotifications,
  RecievedNotifications,
  ManageCms,
  Payment,
  Analytics,
  Modal,
  AddModal,
  AddColorCode,
  ColorCode,
  DriveType,
  AddDriveType,
  Power,
  AddPower,
  FleetDamage,
  AddFleetDamage,
  ManageGCC,
  AddGCC,
  ManageFeatures,
  AddFeatures,
  AddEquipment,
  ManageEquipments,
  ManageTechFeatures,
  AddTechnicalFeatures,
  RegionalSpec,
  AddRegionalSpec,
  PermissionDenied,
  ManageStore,
  ManageCustomerSupport,
  DealerStoreDetail,
  AddTrimModal,
  TrimModal,
  TrimBrand,
  AddTrimBrand,
  FinancialYears,
  FinancialRequests,
  LoanInterestRates,
  AddLoanInterestRates,
  AddFinancialYear,
  NewsLetterEmail,
};
